import { IForm } from '@/components/types'
import { useSearchDateShortcut } from '@/hooks/useSearch'
const shortcuts = useSearchDateShortcut()

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'consumerName',
      type: 'input',
      label: '客户昵称',
      placeholder: '请输入客户昵称'
    },
    // {
    //   field: 'dealType',
    //   type: 'select',
    //   label: '标签',
    //   clearable: true,
    //   placeholder: '请选择标签',
    //   options: [
    //     { title: '未成交', value: 0 },
    //     { title: '全款', value: 1 },
    //     { title: '518', value: 2 },
    //     { title: '同行', value: 3 },
    //     { title: '成交', value: 4 },
    //     { title: '新客户', value: 6 }
    //   ]
    // },
    {
      field: 'channel',
      type: 'select',
      label: '来源渠道',
      clearable: true,
      placeholder: '请选择来源渠道',
      options: [
        { title: '未知', value: '0' },
        { title: '推广素材', value: '1' },
        { title: '复播', value: '2' },
        { title: '直播', value: '3' }
      ]
    },
    // {
    //   field: 'dealTime',
    //   type: 'datepicker',
    //   label: '成交时间',
    //   otherOptions: {
    //     startPlaceholder: '开始时间',
    //     endPlaceholder: '结束时间',
    //     type: 'daterange',
    //     'value-format': 'YYYY-MM-DD'
    //   }
    // },
    {
      field: 'createdTime',
      type: 'datepicker',
      label: '创建时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        },
        shortcuts: shortcuts
      }
    },
    // {
    //   field: 'empTag',
    //   type: 'select',
    //   label: '员工标签',
    //   clearable: true,
    //   placeholder: '请选择员工标签',
    //   options: [
    //     { title: '518', value: 0 },
    //     { title: '投教', value: 1 }
    //   ]
    // },
    {
      field: 'empIds',
      type: 'select',
      label: '员工',
      clearable: true,
      filterable: true,
      placeholder: '请选择员工'
    }
  ]
}
